import StatusBadge, {
  type StatusBadgeProps,
} from "../../status-badge/StatusBadge";
import type { EnumCashierTxStatus } from "@/api/cashier";

/* Map transaction statuses to StatusBadge types */
const transactionStatusMap: Record<
  EnumCashierTxStatus,
  StatusBadgeProps["type"]
> = {
  Unsuccessful: "unsuccessful",
  Pending: "pending",
  Complete: "complete",
  Requested: "requested",
  Processing: "processing",
  Cancelled: "cancelled",
};

/* Check if a string is a valid transaction status */
const isTransactionStatus = (status: string): status is EnumCashierTxStatus =>
  status in transactionStatusMap;

/* The TransactionStatusBadge component for a given transaction status
  @param status - The transaction status to get the badge for
  @returns The StatusBadge component for the status
*/
export const TransactionStatusBadge = ({
  status,
}: {
  status: EnumCashierTxStatus;
}) => {
  const badgeType = isTransactionStatus(status)
    ? transactionStatusMap[status]
    : "pending";
  return <StatusBadge type={badgeType} />;
};
